import React, { memo } from 'react';
import classnames from 'classnames';
import Element from 'src/components/base/element';

interface IProps {
    className?: string;
    children: React.ReactNode;
    position?: 'start' | 'end';
}

function NavbarContainer(props: IProps) {
    const { children, className, position, ...rest } = props;

    return (
        <Element
            {...rest}
            className={classnames(
                {
                    [`navbar-${position}`]: position,
                },
                className
            )}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarContainer);
